import React from "react"
import styled from "styled-components"
import { AppFunctionComponent } from "../../../types"

const List = styled.ul`
  margin: 0;
  padding: 0;

  li {
    border-bottom: 1px solid ${(props) => props.theme.color.borderLight};
  }
`
interface Props {
  children?: React.ReactNode
  className?: string
}

const AccordionList: AppFunctionComponent<Props> = ({
  children,
  className,
}) => {
  return <List className={className}>{children}</List>
}

export default AccordionList
